<template>
  <el-container>
    <el-aside>
      <el-menu :default-openeds="['1', '2', '3', '4', '5']" router>
        <div class="menu-main-title">
          <div class="box">
            <span class="chineseName"
              >企業勞動法務人員能力鑑定證書培訓及考證查詢系統</span
            ><br />
          </div>
        </div>
        <el-menu-item index="0" route="/"
          ><i class="el-icon-s-home"></i>回首頁</el-menu-item
        >
        <el-menu-item index="1" :route="{ name: '/certificate/home/News' }"
          ><i class="el-icon-s-promotion"></i> 訊息管理</el-menu-item
        >
        <el-menu-item index="2" :route="{ name: '/certificate/home/Course' }"
          ><i class="el-icon-s-management"></i> 課程上架</el-menu-item
        >
        <el-submenu index="3">
          <template slot="title"
            ><i class="el-icon-user-solid"></i>會員管理</template
          >
          <el-menu-item
            index="3-1"
            :route="{ name: '/certificate/home/usersManager' }"
            ><i class="el-icon-caret-right"></i>會員列表</el-menu-item
          >
          <el-menu-item
            index="3-2"
            :route="{ name: '/certificate/home/trainAndReTrainSetting' }"
            ><i class="el-icon-caret-right"></i>培訓&複訓設定</el-menu-item
          >
        </el-submenu>
        <el-submenu index="4">
          <template slot="title"
            ><i class="el-icon-s-claim"></i> 考證報名</template
          >
          <el-menu-item
            index="4-1"
            :route="{ name: '/certificate/home/examSessionManager' }"
            ><i class="el-icon-caret-right"></i>場次管理</el-menu-item
          >
          <el-menu-item
            index="4-2"
            :route="{ name: '/certificate/home/examLocationManager' }"
            ><i class="el-icon-caret-right"></i>前台場地管理</el-menu-item
          >
        </el-submenu>
        <el-submenu index="5">
          <template slot="title"
            ><i class="el-icon-s-custom"></i>講師管理</template
          >
          <el-menu-item
            index="5-1"
            :route="{ name: '/certificate/home/lecturerManager' }"
            ><i class="el-icon-caret-right"></i>講師列表</el-menu-item
          >
        </el-submenu>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header class="content-header" style="height: auto">
        <div class="pageName">
          {{ this.$route.meta.title }}
          <el-button style="padding: 5px;" type="info" plain @click="goBack()"
            ><i class="el-icon-arrow-left">上一頁</i></el-button
          >
        </div>
        <el-button class="logoutBtn" @click="logout" size="small"
          >登出</el-button
        >
        <div class="bottom-line"></div>
      </el-header>
      <router-view class="main-content"></router-view>
    </el-container>
  </el-container>
</template>

<script>
import { AdminLogout } from '@/assets/js/api';

export default {
  metaInfo() {
    return {
      title: this.$route.meta.title,
      titleTemplate: '%s | 金豐集團',
    };
  },
  mounted() {
    const myloginStatus = sessionStorage.getItem('_lgists');
    if (
      myloginStatus === '0'
      || myloginStatus === undefined
      || myloginStatus === null
    ) {
      this.$router.push({ name: 'login' });
    }
  },
  methods: {
    logout() {
      AdminLogout()
        .then(() => {
          sessionStorage.removeItem('_admin');
          this.$router.push({ name: 'login' });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
